import { Component, OnInit } from '@angular/core';
import { AdminApiService, AdminSocialLink } from '../../../core/services/admin-api.service';

@Component({
    selector: 'app-admin-social-links',
    templateUrl: './admin-social-links.component.html'
})
export class AdminSocialLinksComponent implements OnInit {

    links: AdminSocialLink[] = [];

    model: AdminSocialLink = {
        id: 0,
        name: '',
        iconKey: '',
        url: '',
        sort: 0,
        status: true
    };

    iconKeys = [
        'linkedin',
        'facebook',
        'instagram',
        'youtube',
        'email'
    ];

    loading = false;
    saving = false;
    successMessage = '';
    errorMessage = '';

    constructor(private adminApi: AdminApiService) { }

    ngOnInit(): void {
        this.getLinks();
    }

    getLinks(): void {
        this.loading = true;
        this.errorMessage = '';

        this.adminApi.getAdminSocialLinks().subscribe(
            (data: AdminSocialLink[]) => {
                this.links = data || [];
                this.loading = false;
            },
            (error) => {
                console.error(error);
                this.errorMessage = 'Social links could not be loaded.';
                this.loading = false;
            }
        );
    }

    newLink(): void {
        this.model = {
            id: 0,
            name: '',
            iconKey: '',
            url: '',
            sort: 0,
            status: true
        };

        this.successMessage = '';
        this.errorMessage = '';
    }

    editLink(item: AdminSocialLink): void {
        this.model = {
            id: item.id,
            name: item.name,
            iconKey: item.iconKey,
            url: item.url,
            sort: item.sort,
            status: item.status
        };

        this.successMessage = '';
        this.errorMessage = '';
    }

    saveLink(): void {
        this.successMessage = '';
        this.errorMessage = '';

        if (!this.model.name || !this.model.iconKey) {
            this.errorMessage = 'Name and icon key are required.';
            return;
        }

        this.saving = true;

        this.adminApi.saveAdminSocialLink(this.model).subscribe(
            () => {
                this.saving = false;
                this.successMessage = 'Social link saved successfully.';
                this.newLink();
                this.getLinks();
            },
            (error) => {
                console.error(error);
                this.saving = false;
                this.errorMessage = 'Social link could not be saved.';
            }
        );
    }

    deleteLink(id: number): void {
        if (!confirm('Delete this social link?')) {
            return;
        }

        this.adminApi.deleteAdminSocialLink(id).subscribe(
            () => {
                this.successMessage = 'Social link deleted.';
                this.getLinks();
            },
            (error) => {
                console.error(error);
                this.errorMessage = 'Social link could not be deleted.';
            }
        );
    }
}